var map = {
	"./feature_buy_cn.png": "dcdc",
	"./feature_buy_en.png": "4561",
	"./feature_buy_id.png": "6ec3",
	"./feature_buy_ko.png": "8f32",
	"./feature_buy_ph.png": "ce3f",
	"./feature_buy_th.png": "d91d",
	"./feature_buy_zh.png": "12da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6933";